// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"ce3f7665","557":"79b79109"}[chunkId] + ".chunk.js";
};